import type { ValueGetterParams } from 'ag-grid-community';
import type { BusinessType } from '../../types/common';
import type { OrganizationUserType, UserWithOrganizationType } from '../../types/user';

/**
 * 所属する組織を調べて区分一覧を返す
 * @param [ValueGetterParams]
 * @returns [string[]] - 商社コードの配列
 */
const businessTypeValueGetter = (params: ValueGetterParams): string[] => {
  const data: UserWithOrganizationType = params.data;
  const organizations: OrganizationUserType[] | undefined = data.organizations;
  // console.log(organizations);
  const businessTypes: BusinessType[] = organizations
    ? organizations.reduce((acc, cur) => {
        const sum: BusinessType[] = cur.businessType ? [...acc, ...cur.businessType] : [...acc];
        return sum;
      }, [])
    : [];
  const filteredBusinessTypes: BusinessType[] = Array.from(new Set(businessTypes));
  // console.log(filteredBusinessTypes);
  return filteredBusinessTypes;
};

export default businessTypeValueGetter;
